var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.notification.type,{tag:"li",class:{ 'super-admin--unauthorized': _vm.notification.text.includes('unauthorized') },attrs:{"notification":_vm.notification},on:{"close":_vm.closeNotification}})
}
var staticRenderFns = []

export { render, staticRenderFns }